import moment from 'moment';
import 'moment/locale/ru';
import trackingDefaultDataTypesHydrator from './trackingDefaultDataTypes';
import trackingTourCriteriaHydrator from './trackingTourCriteria';

const trackingCalendarDataHydrator = async (options) => {
    const trackingCalendarData = {};
    const checkInDateRange = options.tourCriteria.get('checkInDateRange');
    const requestedDays = moment(checkInDateRange.get('to')).diff(checkInDateRange.get('from'), 'days') + 1;
    const percentCovered = Math.round((options.datesWithPricesAmount / requestedDays) * 100);
    const timeFinished = options.timeFinished ? Math.round((options.timeFinished - options.timestamp) / 1000) : 0;
    const trackingDefaultDataTypes = await trackingDefaultDataTypesHydrator(options);
    const trackingTourCriteria = trackingTourCriteriaHydrator(options);

    _.extend(trackingCalendarData, {
        percentCovered,
        timeFinished,
    }, trackingDefaultDataTypes, trackingTourCriteria);

    return trackingCalendarData;
};

export default trackingCalendarDataHydrator;